import styled from "styled-components";
import { Label } from "components/bootstrap";
const InvestigationsLabel = styled(Label)`
  text-transform: uppercase;
  font-weight: bold;
`;
export default InvestigationsLabel;
